<template>
  <div id="store">
    <div class="store-container">
      <UiBox :is-empty="isBoxEmpty">
        <template v-slot:nav-left>
          <UiTab
            v-for="(tab, index) in tabs" 
            :key="index"
            :id="tab.type"
            :active="activeTab === tab.type"
            :class="['tab', tab.type]"
            :data-id="`id-${index}`"
            @click="toggle(tab.type)"
          >
            <div v-show="giftingEnabled" class="tanc" @click="appStore.openModal({ id: 'ranking-rules' })"></div>
            <div class="label-box">
              <span class="label-shadow">{{ tab.name }}</span>
              <span class="label-text">{{ tab.name }}</span>
              <UiTipDot
                v-if="tab.type === 'task' && showLingqu.taskHots.shopTask"
                placement="label"
              ></UiTipDot>
              <UiTipDot
                v-if="tab.type === 'mall' && showLingqu.taskHots.shopList"
                placement="label"
              ></UiTipDot>
              <UiTipDot
                v-if="tab.type === 'dedicate' && showLingqu.taskHots.shopCumul"
                placement="label"
              ></UiTipDot>
            </div>
          </UiTab>
        </template>
        <template v-slot:nav-right>
          <div class="right-mode">
            <div class="right-box" v-if="activeTab === 'mall'"> 
              <UiButton class="history-btn" colorType="red-complex" hook @click="appStore.openModal({ id: 'store-history' })">
                <i></i>
                <div class="label-box">
                  <span class="label-shadow">兑换记录</span>
                  <span class="label-text">兑换记录</span>
                </div>
              </UiButton>
            </div>
            <!-- <div class="times" v-if="activeTab === 0 && countdown !== 0" > 任务刷新：{{ this.countdown }}</div> -->
          </div>
        </template>
        <template v-slot:container>
          <div class="commodity-box" :class="activeTab">
            <RouterView />
          </div>
        </template>
      </UiBox>
    </div>

    <History></History>
    <RankingRules></RankingRules>
    <Exchange></Exchange>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAppStore, useStageStore } from '@/store'
import UiBox from '@/components/ui-box';
import UiTab from '@/components/ui-tab';
import UiButton from '@/components/ui-button';
import History from '@/views/store/mall/history'
import UiTipDot from '@/components/ui-tip-dot.vue'
import RankingRules from '@/views/ranking/modal/ranking-rules.vue'
import Exchange from '@/views/store/mall/exchange'

const STORE_TAB_STORAGE_KEY = 'sausage-match:store-tab'

const storeTabRouteMap = {
  task: 'StoreTask',
  mall: 'StoreMall',
  dedicate: 'StoreDedicate'
}

const route = useRoute()
const router = useRouter()

const appStore = useAppStore()
const stageStore = useStageStore()

// url_pre: 'https://website.xdcdn.net/module/sausage-match/images',
const tabs = ref([
  { name: '任务', type: "task" },
  { name: '商城', type: "mall" },
  { name: '累计人气贡献', type: "dedicate" },
])
const countdown = ref('加载中...')

// 模板 ref 名与导入的组件名重名，使用 useTemplateRef 绑定


const showLingqu = computed(() => appStore.showLingqu)
const giftingEnabled = computed(() => stageStore.giftingEnabled)
// 任务/商城 tab 始终有内容, dedicate tab 依赖 giftingEnabled
const isBoxEmpty = computed(() => activeTab.value === 'dedicate' && !giftingEnabled.value)
const activeTab = computed(() => {
  const routeNameTabMap = {
    StoreTask: 'task',
    StoreMall: 'mall',
    StoreDedicate: 'dedicate'
  }

  return routeNameTabMap[route.name] || getStoredStoreTab() || 'task'
})

function getStoredStoreTab() {
  if (typeof window === 'undefined') {
    return ''
  }
  const storedTab = window.sessionStorage.getItem(STORE_TAB_STORAGE_KEY) || ''
  return storeTabRouteMap[storedTab] ? storedTab : ''
}
function persistStoreTab(tab) {
  if (typeof window === 'undefined') {
    return
  }
  window.sessionStorage.setItem(STORE_TAB_STORAGE_KEY, tab)
}
async function formatCountdown() {
  // 二阶段倒计时由 stage store 统一计算
  const value = await useStageStore().reqPhase2Countdown()
  if (value !== null) {
    countdown.value = value
  }
}
function toggle(type){
  if(activeTab.value === type) return;
  // TODO 二阶段开
  if(type !== 'dedicate'){
    appStore.reqRedDotState()
  }
  persistStoreTab(type)
  // 跳转子路由
  router.push({
    name: storeTabRouteMap[type]
  })
}

watch(() => route.name, () => {
  persistStoreTab(activeTab.value)
}, { immediate: true })

watch(countdown, () => {
  formatCountdown()
}, { immediate: true })


// created
formatCountdown()
</script>

<style lang="scss" scoped>
#store {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    height: get_percentage(730);
    position: relative;
    .tab.dedicate{
        .tanc{
            position: relative;
            @include r(width, 38);
            @include r(height, 38);
            @include icon_status('icon_rule_event');
            @include r(margin, 4, 8, 0, 0);
        }
    }
    .store-container {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .right-mode{
            position: relative;
            // right: get_vh(15);
            height: 100%;
            display: flex;
            align-items: center;
            // justify-content: right;
            color: #fff;
            // width: 100%;
            .tanc{
                position: absolute;
                right: get_vh(10);
                width: get_vh(38);
                height: get_vh(38);
                margin-right: get_vh(38);
                background-image: url('https://website.xdcdn.net/poster/58881/2024_EventsCentre/FiJf6UvY.png');
                background-repeat: no-repeat;
                background-size: cover;
            }
            .times{
                position: absolute;
                right: get_vh(37);
                // margin-right: get_vh(37);
            }
            .right-box {
                width: 100%;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                @include r(font-size, 26);
                color: #fff;
                .history-btn {
                    @include r(width, 130);
                    @include r(height, 40);
                    @include r(font-size, 20);
                    cursor: pointer;
                    -webkit-tap-highlight-color: transparent;
                    @include boxShadowSet_Btn;
                    i {
                        display: inline-block;
                        @include r(width, 25);
                        @include r(height, 25);
                        @include r(margin-right, 5);
                        @include icon_status('btn_store');
                    }
                }
            }
        }
        .commodity-box {
            flex: 1;
            box-sizing: border-box;
            height: 100%;
            padding: get_vh(17) 0 get_vh(10);
            overflow-x: hidden;
            overflow-y: scroll;
            // &.dedicate{
            //    padding: get_vh(17) 0 0;
            // }
        }
        @include hideScrollBar;
    }
}
</style>
